import Vue from 'vue'
import routerPageHook from '@assets/js/routerPageHook.js'
import Banner from '@components/ui-components/banner/component.js'
import { mapActions } from 'vuex'

export default {
  name: 'static-page',
  data() {
    return {
      template: '<main></main>',
    }
  },
  components: {
    'banner-cmp': Banner,
  },
  methods: {
    ...mapActions('modal', ['modalType_collabOpen', 'modalClose']),
  },
  ...routerPageHook,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/pages/_id/index.js